<template>
  <div class="p-5 pt-5 h-screen">
    <div v-html="advertencia" class="text-teal-100 m-4 text-left"></div>
    <form @submit.prevent="registro" class="px-8 pt-6 pb-8 content-start">
      <div class="mb-4">
        <input class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" v-model="email" type="email" placeholder="Email" />
      </div>
      <div class="mb-6">
        <input
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="contrasena"
          type="password"
          placeholder="Contraseña"
        />
      </div>
      <div class="mb-6">
        <input
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="apellido"
          type="text"
          placeholder="Apellido"
        />
      </div>
      <div class="mb-6">
        <input
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="nombre"
          type="text"
          placeholder="Nombre"
        />
      </div>
      <div class="mb-6">
        <input
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="dni"
          type="number"
          placeholder="DNI"
        />
      </div>
      <div class="mb-6">
        <input
          class="shadow appearance-none border border-red-500 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
          v-model="telefono"
          type="text"
          placeholder="Teléfono"
        />
      </div>
      <input type="checkbox" id="chequeado" v-model="chequeado" />
      <label for="chequeado">He leído y acepto <a :href="`http://arturf.com.ar/emp/${empresa}/terminos_y_condiciones.htm`" target="_blank" class="underline">términos y condiciones</a> </label>
      <div class="flex mt-3">
        <button :disabled="!chequeado" class="bg-paleta-3 text-white font-bold py-2 px-4 rounded justify-left">
          Registrarme!
        </button>
      </div>
    </form>
    <div v-if="mensajeErrorRegistro" class="text-white">
      {{ mensajeErrorRegistro }}
    </div>
    <div class="flex items-center justify-between gap-10 px-8 mt-10 m-2">
      <div class="text-white">¿Ya tenes cuenta?</div>
      <router-link to="/" class="underline">Iniciar sesión</router-link>
    </div>
    <p class="text-center text-gray-500 text-xs mt-5">
      &copy;2020 ArTurf. Todos los derechos reservados
    </p>
  </div>
</template>

<script>
import sha1 from "js-sha1";
import { mapState } from "vuex";

export default {
  data: function() {
    return {
      email: "",
      contrasena: "",
      apellido: "",
      nombre: "",
      dni: "",
      telefono: "",
      chequeado: false,
      submitted: false,
      empresa: ""
    };
  },
  mounted: function() {
    this.empresa = process.env.VUE_APP_API_TOKEN.split(".")[0];
    this.$store.dispatch("obtenerAdvertenciaRegistro", { apiToken: process.env.VUE_APP_API_TOKEN });
  },
  methods: {
    registro() {
      this.submitted = true;
      if (this.email && this.contrasena && this.apellido && this.nombre) {
        this.$store.dispatch("registro", {
          email: this.email,
          hashContrasena: sha1(this.contrasena),
          apellido: this.apellido,
          nombre: this.nombre,
          dni: this.dni,
          telefono: this.telefono,
          apiToken: process.env.VUE_APP_API_TOKEN
        });
      }
    }
  },
  computed: {
    ...mapState({
      mensajeErrorRegistro: state => state.sesion.mensajeErrorRegistro,
      advertencia: state => state.sesion.advertenciaRegistro
    })
  }
};
</script>
